import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock } from "components/bootstrap";
import { Spinner, ISODurationInput } from "components/common";
import useTokenTTL from "./useTokenTTL";
const StyledForm = styled.form`
  margin-top: 10px;

  &.form-inline > .form-group {
    margin-right: 10px;

    > input {
      width: 300px;
    }
  }

  .input-group {
    width: 300px;
  }
`;
const CreateTokenForm = ({
  creatingToken = false,
  disableForm = false,
  forceDefaultTtl = void 0,
  disableTtl = false,
  onCreate
}) => {
  const { t } = useTranslation("users");
  const [tokenName, setTokenName] = useState("");
  const { tokenTtl, setTokenTtl, resetTokenTtl } = useTokenTTL(forceDefaultTtl);
  const createToken = (event) => {
    event.preventDefault();
    onCreate({ tokenName, tokenTtl });
    setTokenName("");
    resetTokenTtl();
  };
  const ttlValidator = (milliseconds) => milliseconds >= 6e4;
  return /* @__PURE__ */ React.createElement(StyledForm, { className: "form-inline", onSubmit: createToken }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "create-token-input" }, /* @__PURE__ */ React.createElement(ControlLabel, null, t("token_form.token_name")), /* @__PURE__ */ React.createElement(
    FormControl,
    {
      type: "text",
      disabled: disableForm,
      placeholder: t("token_form.placeholder"),
      value: tokenName,
      onChange: (event) => setTokenName(event.target.value)
    }
  )), !disableTtl && /* @__PURE__ */ React.createElement(
    ISODurationInput,
    {
      id: "token_creation_ttl",
      duration: tokenTtl,
      update: (value) => setTokenTtl(value),
      label: t("token_form.ttl_label"),
      help: "",
      validator: ttlValidator,
      errorText: t("token_form.ttl_invalid"),
      disabled: disableForm,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      id: "create-token",
      disabled: disableForm || tokenName === "" || creatingToken,
      type: "submit",
      bsStyle: "primary"
    },
    creatingToken ? /* @__PURE__ */ React.createElement(Spinner, { text: t("token_form.creating") }) : t("token_form.create")
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, t("token_form.ttl_help")));
};
export default CreateTokenForm;
